import React from 'react';

import Badge from 'components/generic/Badge.component';
import Icon from 'components/generic/Icon.component';

import CN from './UiPage.module.scss'; // Since this is experiment, we can share the same .module.scss file

const BadgesPanel = () => (
  <div data-bem="BadgesPanel" className={CN.container}>
    <div className={CN.container}>
      <div className={CN.verticalFlex}>
        <div className={CN.elementsContainer}>
          <Badge variant="success" disabled>
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}> with icon disabled</span>
            </div>
          </Badge>
          <Badge variant="success" disabled>
            disabled
          </Badge>
          <Badge variant="success" disabled height="md">
            height md
          </Badge>
          <Badge variant="success" disabled height="sm">
            height sm
          </Badge>
          <Badge variant="success" disabled height="xs">
            height xs
          </Badge>
        </div>

        <div className={CN.elementsContainer}>
          <Badge variant="alert">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>alert with icon</span>
            </div>
          </Badge>

          <Badge variant="alert">default alert</Badge>
          <Badge variant="alert" height="md">
            height md
          </Badge>
          <Badge variant="alert" height="sm">
            height sm
          </Badge>
          <Badge variant="alert" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="restricted">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>restricted with icon</span>
            </div>
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="raspberry">raspberry</Badge>
        </div>

        <div className={CN.elementsContainer}>
          <Badge variant="attention">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>attention with icon</span>
            </div>
          </Badge>
          <Badge variant="attention">default attention</Badge>
          <Badge variant="attention" height="md">
            height md
          </Badge>
          <Badge variant="attention" height="sm">
            height sm
          </Badge>
          <Badge variant="attention" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="warning">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>warning with icon</span>
            </div>
          </Badge>
          <Badge variant="warning">default warning</Badge>
          <Badge variant="warning" height="md">
            height md
          </Badge>
          <Badge variant="warning" height="sm">
            height sm
          </Badge>
          <Badge variant="warning" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="outline">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>outline with icon</span>
            </div>
          </Badge>
          <Badge variant="outline">default outline</Badge>
          <Badge variant="outline" height="md">
            height md
          </Badge>
          <Badge variant="outline" height="sm">
            height sm
          </Badge>
          <Badge variant="outline" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="sky">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>sky with icon</span>
            </div>
          </Badge>
          <Badge variant="sky">default sky</Badge>
          <Badge variant="sky" height="md">
            height md
          </Badge>
          <Badge variant="sky" height="sm">
            height sm
          </Badge>
          <Badge variant="sky" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="unlimited">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>unlimited with icon</span>
            </div>
          </Badge>
          <Badge variant="unlimited">default unlimited</Badge>
          <Badge variant="unlimited" height="md">
            height md
          </Badge>
          <Badge variant="unlimited" height="sm">
            height sm
          </Badge>
          <Badge variant="unlimited" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="fine">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>fine with icon</span>
            </div>
          </Badge>
          <Badge variant="fine">default fine</Badge>
          <Badge variant="fine" height="md">
            height md
          </Badge>
          <Badge variant="fine" height="sm">
            height sm
          </Badge>
          <Badge variant="fine" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="success">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>success with icon</span>
            </div>
          </Badge>
          <Badge variant="success">default success</Badge>
          <Badge variant="success" height="md">
            height md
          </Badge>
          <Badge variant="success" height="sm">
            height sm
          </Badge>
          <Badge variant="success" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="fb">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>fb with icon</span>
            </div>
          </Badge>
          <Badge variant="fb">default fb</Badge>
          <Badge variant="fb" height="md">
            height md
          </Badge>
          <Badge variant="fb" height="sm">
            height sm
          </Badge>
          <Badge variant="fb" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="draft">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>draft with icon</span>
            </div>
          </Badge>
          <Badge variant="draft">default draft</Badge>

          <Badge variant="draft" height="md">
            height md
          </Badge>
          <Badge variant="draft" height="sm">
            height sm
          </Badge>
          <Badge variant="draft" height="xs">
            height xs
          </Badge>
        </div>

        <div className={CN.elementsContainer}>
          <Badge variant="plan">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>plan with icon</span>
            </div>
          </Badge>
          <Badge variant="plan">default plan</Badge>
          <Badge variant="plan" height="md">
            height md
          </Badge>
          <Badge variant="plan" height="sm">
            height sm
          </Badge>
          <Badge variant="plan" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="slick">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>slick with icon</span>
            </div>
          </Badge>
          <Badge variant="slick">default slick</Badge>
          <Badge variant="slick" height="md">
            height md
          </Badge>
          <Badge variant="slick" height="sm">
            height sm
          </Badge>
          <Badge variant="slick" height="xs">
            height xs
          </Badge>
        </div>
        <div className={CN.elementsContainer}>
          <Badge variant="slickLight">
            <div className={CN.buttonInner}>
              <Icon variant="xCircleSolid" width="md" />
              <span className={CN.withIcon}>slickLight with icon</span>
            </div>
          </Badge>
          <Badge variant="slickLight">default slickLight</Badge>
          <Badge variant="slickLight" height="md">
            height md
          </Badge>
          <Badge variant="slickLight" height="sm">
            height sm
          </Badge>
          <Badge variant="slickLight" height="xs">
            height xs
          </Badge>
        </div>

        <div className={CN.inline}>
          <Badge name="New Feature 🚀" variant="menu" />
          <Badge name="Have this" variant="normal">
            <Icon variant="on" />
          </Badge>
          <Badge name="Not this" variant="normal">
            <Icon variant="off" />
          </Badge>
        </div>
      </div>
    </div>
  </div>
);

// noinspection JSUnusedGlobalSymbols
export default BadgesPanel;
